import { useIntl } from '@weenat/wintl'
import { isNil } from 'lodash-es'
import { ReactNode } from 'react'
import EmptyStateWithRipple from '../empty-state/EmptyStateWithRipple'
import Icons from '../Icons'
import LoadingCircle from '../loaders/LoadingCircle'
import Text from '../Text'

interface ChartWrapperProps {
  /** height of the cart to avoid layout shifts - defaults to 240 */
  height: number
  isLoading: boolean
  isEmpty: boolean
  /** for custom empty state */
  emptyState?: ReactNode
}

/**
 * Simple component that will wrap charts to show a loading or an empty state
 */
const ChartWrapper: FC<ChartWrapperProps> = ({
  children,
  isLoading,
  isEmpty,
  height = 240,
  emptyState
}) => {
  const { t } = useIntl()

  return isLoading || isEmpty ? (
    <Flex
      $flexDirection='column'
      $backgroundColor='grayscale.100'
      $alignItems='center'
      $justifyContent='center'
      $gap={'md'}
      $height={height}
      $width={'100%'}
      $borderRadius={'sm'}
    >
      {isLoading ? (
        <>
          <LoadingCircle />
          <Text $textAlign='center'>{t('status.loading')}</Text>
        </>
      ) : isEmpty ? (
        !isNil(emptyState) ? (
          emptyState
        ) : (
          <EmptyStateWithRipple Icon={Icons.BarChart} description={t('charts.no_data')} />
        )
      ) : null}
    </Flex>
  ) : (
    children
  )
}

export default ChartWrapper
